<template>
    <b-col cols="12" class="p-3">
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template>
    </b-col>
</template>

<script>
    import { Popover } from 'bootstrap';

    export default {
        components: {},
        props: {
            zonas: {
                type: Array,
                required: true
            }, 
            seccion: {
                type: Object,
                required: true
            },
            zona_id: {
                type: Number,
                required: false
            },
            svg: {
                type: String,
                required: true
            },
            relaxedGuards: {
                type: Boolean,
                default: false
            },
            /**
             * When true, SVG regions without a matching zona in the payload are
             * treated as unavailable (deny-by-default, greyed out). Opt-in per
             * teatro: the admin taquilla flow (relaxedGuards) and teatros outside
             * the strict-prices list keep the legacy "no class" behaviour.
             */
            strictRegions: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                reg: null,
                load_popover: true,
                popovers: [],
                popoverTargets: []
            }            
        },
        created() {
            this.loadSVG(this.svg);
        
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }
        },
        beforeDestroy() {
            this.destroyPopovers();
            // Limpieza de seguridad: al destruir el componente no debería
            // haber otros popovers visibles en este punto del flujo
            var orphans = document.querySelectorAll('.popover');
            for (var o = 0; o < orphans.length; o++) {
                orphans[o].remove();
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods : {
            destroyPopovers() {
                this.popovers.forEach(function(p) {
                    var tip = p._tip || p.tip;
                    p.hide();
                    p.dispose();
                    if (tip && tip.parentNode) {
                        tip.remove();
                    }
                });
                this.popovers = [];
                this.popoverTargets.forEach(function(target) {
                    var describedBy = target.getAttribute('aria-describedby');
                    if (describedBy) {
                        var el = document.getElementById(describedBy);
                        if (el) el.remove();
                    }
                    target.removeAttribute('aria-describedby');
                    // Prevenir que Bootstrap recree el popover al seguir el mouse encima
                    target.style.pointerEvents = 'none';
                });
            },
            getAsientosLibres(zona) {
                if(zona.libres >= 0) {
                    return zona.libres;
                }

                if(zona.libres < 0) {
                    return 0;
                }

                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                aforo = aforo - zona.confirmados - zona.bloqueados - zona.no_confirmados - zona.sesion;

                if(aforo < 0) {
                    aforo = 0;
                }

                return aforo;
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;
                var attempts = 0;

                var tryProcess = function() {
                    if (!vue_instance.zonas || vue_instance.zonas.length === 0) {
                        if (attempts < 30) {
                            attempts++;
                            setTimeout(tryProcess, 200);
                        }
                        return;
                    }

                    var regions = document.getElementsByClassName("recinto-zona");

                    vue_instance.reg = regions;

                    var darkenRegion = function(region) {
                        region.classList.add("plaza_ocupada");
                        var children = region.querySelectorAll('*');
                        for (var k = 0; k < children.length; k++) {
                            children[k].style.fill = '#374151';
                            children[k].style.opacity = '0.5';
                            children[k].style.filter = 'blur(1px)';
                        }
                    };

                    for (var i = 0; i < regions.length; i++) {
                        if (regions[i].dataset !== undefined) {
                            var region_id = regions[i].dataset.region;

                            var matchedZona = null;
                            for (var j = 0; j < vue_instance.zonas.length; j++) {
                                if (vue_instance.zonas[j].id == region_id) {
                                    matchedZona = vue_instance.zonas[j];
                                    break;
                                }
                            }

                            if (vue_instance.strictRegions && matchedZona === null) {
                                // Region present in the SVG but absent from the
                                // zonas payload: unknown availability, so it must
                                // not react to hover or clicks. Same deny-by-default
                                // treatment as ShowSvgSectionsComponent.
                                darkenRegion(regions[i]);
                                if (vue_instance.load_popover) {
                                    vue_instance.attachUnknownPopover(regions[i]);
                                }
                                continue;
                            }

                            var zonaData = matchedZona;
                            var isAvailable = zonaData.esta_disponible;

                            if (!isAvailable) {
                                // Darken unavailable zones
                                darkenRegion(regions[i]);
                            }

                            // Create native Bootstrap popover
                            // BootstrapVue b-popover does not support SVG target elements
                            // in this component; using native Bootstrap Popover instead.
                            if (vue_instance.load_popover) {
                                var content = '';
                                if (isAvailable) {
                                    content = '<div>Disponible</div>';
                                    if (zonaData.libres >= 0) {
                                        content += '<div>Libres: ' + zonaData.libres + '</div>';
                                    }
                                    if (zonaData.precios && zonaData.precios.length > 0) {
                                        content += '<div>Desde: ' + zonaData.precios[0].precio + ' €</div>';
                                    }
                                } else {
                                    content = zonaData.tiene_precios ? 'Agotadas' : 'No disponible';
                                }
                                var popover = new Popover(regions[i], {
                                    title: zonaData.name || zonaData.nombre || '',
                                    content: content,
                                    trigger: 'hover',
                                    html: true
                                });
                                vue_instance.popovers.push(popover);
                                vue_instance.popoverTargets.push(regions[i]);
                            }

                            if (isAvailable || vue_instance.relaxedGuards) {
                                regions[i].addEventListener('click', function() {
                                    vue_instance.clickRegion(this.dataset.region);
                                }, false);
                            }
                        }
                    }
                    
                    vue_instance.loading = false;
                    vue_instance.$emit('cargado');
                };

                setTimeout(tryProcess, 1000);
            },
            /**
             * Popover for SVG regions with no matching zona in the payload.
             * Bootstrap hides the header when title is empty, so the body
             * alone carries the message.
             */
            attachUnknownPopover(region) {
                var popover = new Popover(region, {
                    title: '',
                    content: 'No disponible',
                    trigger: 'hover',
                    html: true
                });
                this.popovers.push(popover);
                this.popoverTargets.push(region);
            },
            clickRegion : function(region_id) {
                this.destroyPopovers();
                document.querySelectorAll('.popover').forEach(function(el) { el.remove(); });

                let zona = null;
                for (var i = 0; i < this.zonas.length; i++) {
                    if (this.zonas[i].id == region_id) {
                        zona = this.zonas[i];
                    }
                }

                if(zona) {
                    if(! this.seccion.tiene_secciones) {
                        if(this.relaxedGuards || (this.can_click && zona.esta_disponible && this.getAsientosLibres(zona) > 0 && zona.precios.length > 0)) {
                            this.$emit('clickZona', zona);
                        }
                    } else {
                        this.$emit('clickZona', zona);
                    }                
                }            
            }
        }
    }
</script>